<div class="w-full grid grid-cols-13 2xl:grid-cols-14 justify-center content-center gap-2">

  <!-- Fuente de emisión -->
  <div class="hidden">
    <div class="form-control">
      <label for="emissionSource" class="font-semibold">Fuente de emisión</label>
      <div class="form-input-row">
        <p-select
          fluid
          id="emissionSource"
          [options]="emissionSourceOptions"
          [(ngModel)]="selectedEmissionSource"
          optionLabel="label"
          placeholder="Seleccionar fuente de emisión"
          [group]="true">
          <ng-template let-group #group>
            <span class="text-xs! text-gray-400">{{ group.label }}</span>
          </ng-template>
        </p-select>
      </div>
    </div>
  </div>

  <!-- Variación -->
  <div class="col-span-12 md:col-span-6 lg:col-span-4 2xl:col-span-3">
    <div class="form-control">
      <label for="emissionType" class="font-semibold">Fuente de emisión</label>
      <div class="form-input-row">
        <p-select
          fluid
          id="emissionType"
          [options]="emissionTypeOptions"
          [(ngModel)]="selectedEmissionType"
          (onChange)="onEmissionTypeChange()"
          optionLabel="label"
          placeholder="Seleccionar fuente de emisión"
          [group]="true"
          [invalid]="!selectedEmissionType && isSubmitted">
          <ng-template let-group #group>
            <span class="text-xs! text-gray-400">{{ group.label }}</span>
          </ng-template>
        </p-select>
      </div>
      <div class="form-error">
        @if (!selectedEmissionType && isSubmitted) {
        <p-message severity="error" size="small" variant="simple">
          El campo es obligatorio.
        </p-message>
        }
      </div>
    </div>
  </div>

  <!-- Referencia -->
  <div class="col-span-12 md:col-span-6 lg:col-span-4 2xl:col-span-3">
    <div class="form-control">
      <label for="reference" class="font-semibold">Referencia</label>
      <div class="form-input-row">
        <p-select
          fluid
          id="reference"
          [options]="referenceOptions"
          [(ngModel)]="selectedReference"
          [disabled]="!selectedEmissionType"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleccionar referencia"
          [invalid]="!selectedReference && isSubmitted">
        </p-select>
      </div>
      <div class="form-error">
        @if (!selectedReference && isSubmitted) {
        <p-message severity="error" size="small" variant="simple">
          El campo es obligatorio.
        </p-message>
        }
      </div>
    </div>
  </div>

  <!-- Año -->
  <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-2">
    <div class="form-control">
      <label for="year" class="font-semibold">Año</label>
      <div class="form-input-row">
        <p-select
          fluid
          id="year"
          [options]="yearOptions"
          [(ngModel)]="selectedYear"
          placeholder="Año"
          [invalid]="!selectedYear && isSubmitted">
        </p-select>
      </div>
      <div class="form-error">
        @if (!selectedYear && isSubmitted) {
        <p-message severity="error" size="small" variant="simple">
          El campo es obligatorio.
        </p-message>
        }
      </div>
    </div>
  </div>

  <!-- Potencial Calentamiento Global -->
  <div class="col-span-12 md:col-span-6 lg:col-span-2 2xl:col-span-2">
    <div class="form-control">
      <label for="pcg" class="font-semibold">PCG</label>
      <div class="form-input-row">
        <p-select
          fluid
          id="pcg"
          [options]="globalWarmingPotential()"
          [(ngModel)]="selectedGlobalWarmingPotential"
          (onChange)="onGwpChange()"
          optionLabel="Reference"
          optionValue="Id"
          placeholder="PCG"
          [invalid]="!selectedGlobalWarmingPotential && isSubmitted">
        </p-select>
      </div>
      <div class="form-error">
        @if (!selectedGlobalWarmingPotential && isSubmitted) {
        <p-message severity="error" size="small" variant="simple">
          El campo es obligatorio.
        </p-message>
        }
      </div>
    </div>
  </div>

  <!-- Botones de acción -->
  <div class="col-span-12 md:col-span-6 2xl:col-span-3 flex flex-col md:flex-row gap-2 mt-2 2xl:mt-0">
    <div class="form-control">
      <label class="opacity-0 select-none hidden 2xl:block">Acción</label>
      <div class="form-input-row">
        <p-button fluid label="Buscar" (onClick)="handleSearch()" type="button" class="w-full" />
      </div>
      <div class="form-error"></div>
    </div>

    @if (mode() === 'manual') {
    <div class="form-control">
      <label class="opacity-0 select-none hidden 2xl:block">Acción</label>
      <div class="form-input-row">
        <p-button fluid label="Añadir actividad" (onClick)="handleAddActivity()" class="w-full whitespace-nowrap"
          [loading]="loading()" />
      </div>
      <div class="form-error"></div>
    </div>

    <div class="form-control">
      <label class="opacity-0 select-none hidden 2xl:block">Acción</label>
      <div class="form-input-row">
        <p-button fluid label="Descargar" (onClick)="handleDownload()" [disabled]="disableDownload()"
          [loading]="isDownloading()" pTooltip="Descargar Excel" class="w-full" />
      </div>
      <div class="form-error"></div>
    </div>
    }

    @if (mode() === 'excel') {
    <div class="form-control">
      <label class="opacity-0 select-none hidden 2xl:block">Acción</label>
      <div class="form-input-row">
        <p-button fluid label="Descargar plantilla" class="w-full whitespace-nowrap"
          (onClick)="handleDownloadTemplate()" [loading]="loading()" />
      </div>
      <div class="form-error"></div>
    </div>

    <div class="form-control">
      <label class="opacity-0 select-none hidden 2xl:block">Acción</label>
      <div class="form-input-row">
        <input type="file" #excelFileInput class="hidden" accept=".xlsx, .xls" (change)="handleUploadExcel($event)" />
        <p-button fluid label="Cargar Excel" class="w-full whitespace-nowrap" (onClick)="excelFileInput.click()"
          [loading]="loading()" />
      </div>
      <div class="form-error"></div>
    </div>
    }
  </div>
</div>

<p-toast />